"use strict";
const linkContainer = document.querySelectorAll(".dropdown-menu.bg-nav");

linkContainer &&
  linkContainer.forEach((container) => {
    const mOver = () => {
      container.previousElementSibling.setAttribute(
        "style",
        "background-color: #ffa600; border-radius: 10px;   border-bottom-left-radius: 0; border-bottom-right-radius: 0;"
      );
    };

    const mOut = () => {
      container.previousElementSibling.setAttribute(
        "style",
        "background-color:transparent; border-radius: 0;"
      );
    };

    container.addEventListener("mouseover", mOver, false);
    container.addEventListener("mouseout", mOut, false);
  });
